/* Porter - 5 Reasons page script. Accordions, live picker, gallery, calls to
   action, sticky bar, pinned top bars. Ours, inline in the theme, no network. */
(function () {
  'use strict';
  var CART = '/cart/';

  function money(cents, fmt) {
    var n = (cents / 100);
    function sep(s, thou, dec) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    var out = fmt || '${{amount}}';
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sep(n.toFixed(0), '.', ','));
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, sep(n.toFixed(2), '.', ','));
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep(n.toFixed(0), ',', '.'));
    out = out.replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, sep(n.toFixed(2), ' ', ','));
    out = out.replace(/\{\{\s*amount\s*\}\}/g, sep(n.toFixed(2), ',', '.'));
    return out;
  }

  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 || r.height > 0;
  }

  /* Pinned bars: the header sits under whatever height the announcement bar has. */
  function pin() {
    var bar = document.querySelector('.lp-pin-bar');
    var h = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--lp-bar-h', h + 'px');
  }

  /* Accordions: the trigger is a button, the panel the section after its heading. */
  function panelOf(btn) {
    var h = btn.closest('h2');
    var el = h ? h.nextElementSibling : null;
    while (el && el.tagName !== 'SECTION') { el = el.nextElementSibling; }
    return el;
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-slot="trigger"],[data-slot=trigger]');
    if (!btn) { return; }
    var panel = panelOf(btn);
    if (!panel) { return; }
    ev.preventDefault();
    var open = btn.getAttribute('aria-expanded') === 'true';
    panel.style.cssText = open ? 'will-change:auto;opacity:0;height:0px;overflow-y:hidden'
                               : 'will-change:auto;opacity:1;height:auto;overflow-y:visible';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  }, false);

  /* Picker state shared by every call to action on the page. */
  var state = { variant: null, values: [] };

  /* Variant keys are the product's option order (Size|Color). The rows may
     render in another order (color on top), so every input carries its option
     position and the values are placed by position, never by row order. */
  function rowPos(g) {
    var inp = g.querySelector('input');
    return inp ? parseInt(inp.getAttribute('data-lp-option'), 10) - 1 : 0;
  }
  function readPicker(p) {
    var V = JSON.parse(p.getAttribute('data-variants') || '{}');
    var values = [];
    [].slice.call(p.querySelectorAll('.lp-row')).forEach(function (g) {
      var c = g.querySelector('input:checked');
      values[rowPos(g)] = c ? c.value : '';
    });
    for (var i = 0; i < values.length; i++) { if (values[i] === undefined) { values[i] = ''; } }
    return { V: V, values: values, v: V[values.join('|')] };
  }

  /* Allan, 2026-09-04: hide anything out of stock rather than greying it. The
     chosen value itself is never hidden, so the picker cannot lose its state. */
  function greyOut(p, V, values) {
    [].slice.call(p.querySelectorAll('.lp-row')).forEach(function (g) {
      var i = rowPos(g);
      var chosen = g.querySelector('input:checked');
      var lbl = g.parentElement && g.parentElement.querySelector('[data-lp-value]');
      if (lbl && chosen) { lbl.textContent = ': ' + chosen.value; }
      g.querySelectorAll('label').forEach(function (l) {
        var inp = l.querySelector('input');
        var trial = values.slice();
        trial[i] = inp.value;
        var vv = V[trial.join('|')];
        var out = !(vv && vv[2]);
        l.classList.toggle('lp-out', out);
        l.hidden = out && !inp.checked;
      });
    });
  }

  function fill(tpl, values) {
    return (tpl || '').replace(/\{option(\d)\}/g, function (_, n) { return values[n - 1] || ''; });
  }

  function apply(p, lead) {
    var r = readPicker(p);
    greyOut(p, r.V, r.values);
    var box = p.closest('[data-lp-buy-box]') || document;
    var note = p.querySelector('.lp-note');
    var v = r.v;
    box.querySelectorAll('[data-lp-gallery]').forEach(function (g) { filterGallery(g, r.values); });
    if (!v) {
      if (note) { note.textContent = fill(p.getAttribute('data-unavailable'), r.values); }
      setDisabled(box, true);
      return;
    }
    var ok = !!v[2];
    if (note) { note.textContent = fill(p.getAttribute(ok ? 'data-note' : 'data-soldout'), r.values); }
    setDisabled(box, !ok);
    box.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v[0]; });
    if (!lead) { return; }
    var fmt = p.getAttribute('data-money-format');
    document.querySelectorAll('[data-lp-price]').forEach(function (el) { el.textContent = money(v[1], fmt); });
    document.querySelectorAll('[data-lp-price-btn]').forEach(function (el) { el.textContent = money(v[1], fmt); });
    var gifts = parseInt(p.getAttribute('data-gifts-cents') || '0', 10) || 0;
    document.querySelectorAll('[data-lp-compare]').forEach(function (el) {
      el.hidden = !(gifts > 0);
      el.textContent = money(v[1] + gifts, fmt);
    });
    state.variant = v;
    state.values = r.values;
    state.available = ok;
    wireCtas();
    document.dispatchEvent(new CustomEvent('lp:variant', { detail: { variant: v, values: r.values } }));
  }

  function setDisabled(box, off) {
    box.querySelectorAll('[data-lp-add]').forEach(function (b) {
      b.disabled = off;
      b.classList.toggle('lp-disabled', off);
    });
  }


  /* Banner on each colour's first gallery photo: the cross folds it into a small tab
     (every colour at once), a click on the tab opens it again, and "Learn more" shows
     the study footnote. The sibling page's own behaviour. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) { return; }
    if (t.closest('[data-lusome-proof-close]')) {
      document.querySelectorAll('[data-lusome-proof]').forEach(function (el) { el.classList.add('is-collapsed'); });
    } else if (t.closest('[data-lusome-proof].is-collapsed')) {
      document.querySelectorAll('[data-lusome-proof]').forEach(function (el) { el.classList.remove('is-collapsed'); });
    } else if (t.closest('[data-lusome-proof-note]')) {
      var wrap = t.closest('[data-lusome-proof]');
      var note = wrap && wrap.querySelector('.lusome-proof__note');
      var show = note ? note.hidden : false;
      document.querySelectorAll('[data-lusome-proof] .lusome-proof__note').forEach(function (n) { n.hidden = !show; });
    }
  });

  /* Allan, 08/09/2026: every call to action scrolls to the buy box, and the buy
     box's own Shop Now leaves for the page named in its Buy button setting. */
  function goTo(target) {
    if (target.charAt(0) === '#') {
      var t = document.querySelector(target);
      if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    }
    window.location.href = target;
  }

  function wireCtas() {
    document.querySelectorAll('[data-lp-cta]').forEach(function (el) {
      var over = el.getAttribute('data-lp-href');
      var target = (over && over.trim()) || '#lp-buy-box';
      if (el.tagName === 'A') {
        el.setAttribute('href', target);
      }
      el.onclick = function (e) { e.preventDefault(); goTo(target); };
      el.style.cursor = 'pointer';
    });
  }

  /* Gallery: the slides tagged with the chosen colour, video kept in its slot. */
  function filterGallery(g, values) {
    var vals = values.map(function (x) { return (x || '').trim().toLowerCase(); });
    var slides = [].slice.call(g.querySelectorAll('[data-lp-slide]'));
    var track = g.querySelector('[data-lp-track]');
    var rail = g.querySelector('[data-lp-rail]');
    if (!track) { return; }
    function match(el) {
      var c = (el.getAttribute('data-lp-colour') || '').trim().toLowerCase();
      return !c || vals.indexOf(c) >= 0;
    }
    var slot = parseInt(g.getAttribute('data-lp-video-slot') || '5', 10);
    var imgs = slides.filter(function (s) { return !s.hasAttribute('data-lp-video') && match(s); });
    var vids = slides.filter(function (s) { return s.hasAttribute('data-lp-video') && match(s); });
    var order = imgs.slice();
    vids.forEach(function (v, i) { order.splice(Math.min(slot - 1 + i, order.length), 0, v); });
    slides.forEach(function (s) { s.hidden = order.indexOf(s) < 0; });
    order.forEach(function (s) { track.appendChild(s); });
    var thumbs = order.map(function (s) {
      return g.querySelector('[data-lp-thumb][data-lp-key="' + s.getAttribute('data-lp-key') + '"]');
    });
    [].slice.call(g.querySelectorAll('[data-lp-thumb]')).forEach(function (t) { t.hidden = thumbs.indexOf(t) < 0; });
    if (rail) { thumbs.forEach(function (t) { if (t) { rail.appendChild(t); } }); }
    g._lpOrder = order;
    g._lpThumbs = thumbs;
    go(g, 0);
  }

  function go(g, i) {
    var order = g._lpOrder || [];
    if (!order.length) { return; }
    i = (i + order.length) % order.length;
    g._lpIndex = i;
    var track = g.querySelector('[data-lp-track]');
    track.style.transition = 'transform .35s ease';
    track.style.transform = 'translate3d(-' + (i * 100) + '%,0,0)';
    (g._lpThumbs || []).forEach(function (t, k) {
      if (!t) { return; }
      var card = t.firstElementChild || t;
      card.classList.toggle('opacity-100', k === i);
      card.classList.toggle('opacity-75', k !== i);
      card.classList.toggle('border-image', k === i);
      card.classList.toggle('border-foreground/20', k !== i);
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    order.forEach(function (s, k) {
      var v = s.querySelector('video');
      if (!v) { return; }
      if (k === i) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } else { v.pause(); }
    });
  }

  function wireGallery(g) {
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lp-thumb]');
      if (t) { var k = (g._lpThumbs || []).indexOf(t); if (k >= 0) { go(g, k); } return; }
      var b = e.target.closest('button');
      if (b && g.contains(b)) {
        var l = (b.getAttribute('aria-label') || '').toLowerCase();
        var vid = b.parentElement ? b.parentElement.querySelector('video') : null;
        if (/prev|back|left/.test(l)) { e.preventDefault(); go(g, (g._lpIndex || 0) - 1); }
        else if (/next|forward|right/.test(l)) { e.preventDefault(); go(g, (g._lpIndex || 0) + 1); }
        else if (/mute/.test(l) && vid) { e.preventDefault(); vid.muted = !vid.muted; }
        else if (/play/.test(l) && vid) { e.preventDefault(); if (vid.paused) { vid.play(); } else { vid.pause(); } }
      }
    });
    var track = g.querySelector('[data-lp-track]');
    if (!track) { return; }
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { go(g, (g._lpIndex || 0) + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
  }

  /* Sticky bar: thumbnail follows the chosen colour, gate follows the setting. */
  document.addEventListener('lp:variant', function (e) {
    var v = e.detail.variant;
    if (v && v[3]) {
      document.querySelectorAll('[data-lp-sticky-img]').forEach(function (img) { img.src = v[3]; });
    }
  });
  function stickyGate() {
    var bars = [].slice.call(document.querySelectorAll('[data-lp-sticky][data-lp-show="buy_box"]'));
    if (!bars.length) { return; }
    function check() {
      var boxes = [].slice.call(document.querySelectorAll('[data-lp-buy-box]')).filter(visible);
      var passed = boxes.some(function (b) { return b.getBoundingClientRect().bottom <= window.innerHeight; });
      bars.forEach(function (b) { b.classList.toggle('lp-sticky-off', !passed); });
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
  }

  /* The store's Klaviyo signup form covers the hero on a page paid traffic lands
     on. Removed on this template only, the same call Allan made on Zend
     (2026-09-01). The durable fix is a Klaviyo targeting rule excluding this URL. */
  function blockStorePopup() {
    var SEL = '[class*="kl-private-reset-css"]';
    function kill() {
      var found = false;
      document.querySelectorAll(SEL).forEach(function (n) {
        var box = n.closest('div' + SEL) || n;
        if (box && box.parentNode) { box.parentNode.removeChild(box); found = true; }
      });
      if (found) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }
    kill();
    window.addEventListener('klaviyoForms', function (e) {
      if (e && e.detail && e.detail.type === 'open') { kill(); }
    });
    new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Some browsers hold a muted autoplay until the page is touched. */
  function kick() {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); }
    });
  }

  function wireCartForms() {
    document.querySelectorAll('.lp-form').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (form.dataset.adding === 'true') return;
        var button = form.querySelector('[data-lp-add]');
        var status = form.querySelector('[data-lp-cart-status]');
        var picker = form.closest('[data-lp-buy-box]').querySelector('[data-lp-picker]');
        var selection = readPicker(picker).v;
        if (!selection || !selection[2]) {
          status.textContent = 'Please choose an available size and colour.';
          return;
        }
        form.dataset.adding = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = 'Adding your sheets...';
        try {
          var response = await fetch(form.action + '.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: selection[0], quantity: 1}]})
          });
          var result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add these sheets. Please try again.');
          status.textContent = 'Sheets added. ';
          var link = document.createElement('a');
          link.href = form.querySelector('[name="return_to"]').value;
          link.textContent = 'View cart';
          status.appendChild(link);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          status.textContent = error.message || 'Unable to add these sheets. Please try again.';
        } finally {
          form.dataset.adding = 'false';
          button.disabled = !readPicker(picker).v?.[2];
          button.removeAttribute('aria-busy');
        }
      });
    });
  }

  function init() {
    wireCartForms();
    pin();
    window.addEventListener('resize', pin);
    document.querySelectorAll('[data-lp-gallery]').forEach(wireGallery);
    var pickers = [].slice.call(document.querySelectorAll('[data-lp-picker]'));
    pickers.forEach(function (p) {
      p.addEventListener('change', function () { apply(p, true); });
    });
    var lead = pickers.filter(visible)[0] || pickers[0];
    pickers.forEach(function (p) { apply(p, p === lead); });
    if (!lead) { wireCtas(); }
    window.addEventListener('resize', function () {
      var now = pickers.filter(visible)[0];
      if (now && now !== lead) { lead = now; apply(now, true); }
    });
    stickyGate();
    blockStorePopup();
    kick();
    ['scroll', 'touchstart', 'click'].forEach(function (e) {
      window.addEventListener(e, kick, { once: true, passive: true });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
